import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconOverview: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M9 2.625C4.85786 2.625 1.5 5.98286 1.5 10.125C1.5 12.0863 2.14254 14.0386 3.375 15.375H14.625C15.8575 14.0386 16.5 12.0863 16.5 10.125C16.5 5.98286 13.1421 2.625 9 2.625Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9 12.75C9.82843 12.75 10.5 12.0784 10.5 11.25C10.5 10.4216 9.82843 9.75 9 9.75C8.17157 9.75 7.5 10.4216 7.5 11.25C7.5 12.0784 8.17157 12.75 9 12.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M9 7.5V9.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M9 4.5V5.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M3.375 10.5H4.125" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path
      d="M4.875 6.75L5.40532 7.28032"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.875 10.5H14.625"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.75 7.28032L13.2803 6.75"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
